import React, { useEffect, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";
import { IoEye } from "react-icons/io5";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Constant from "../Components/Utils/Constant";

export default function CreateUser({ onClose }) {
  const [isVisible, setIsVisible] = useState(true);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [device, setDevice] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [address, setAddress] = useState("");
  const [proffesion, setProffesion] = useState("");
  const [gst, setGst] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [createdby, setCreatedby] = useState("");
  const [userName, setUserName] = useState("");
  const [cuponapplied, setCuponapplied] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isGstValid, setIsGstValid] = useState(true);
  const [date, setDate] = useState("");
  const [usertype, setUsertype] = useState("");
  const [isSubscriptionOpen, setIsSubscriptionOpen] = useState(false);

  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const storedName = localStorage.getItem("name");
    if (storedName) {
      setUserName(storedName);
      setCreatedby(storedName);
    } else {
      setUserName("Unauthorized");
      setCreatedby("Unauthorized");
    }
  }, []);

  // Fetch subscription plans on component mount
  useEffect(() => {
    // ✅ This function correctly uses async/await
    const fetchSubscriptionPlans = async () => {
      try {
        setIsLoading(true);
        // await pauses execution until the promise resolves
        const response = await axios.get(
          `${Constant.BASE_URL}/subscription/admin-plans`
        );
        setSubscriptionPlans(response.data.subscription || []);
        console.log("Fetched plans:", response.data);
        setError(null);
      } catch (err) {
        console.error("Failed to fetch subscription plans:", err);
        setError("Could not load subscription plans.");
        toast.error("Could not load subscription plans.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSubscriptionPlans();
  }, []); // Empty dependency array ensures this runs only once

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhone = (phone) => /^\d{10}$/.test(phone);
  const validateGst = (gst) => {
    if (gst.trim() === "") return true;
    const gstRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[Z]{1}\d{1}$/;
    return gstRegex.test(gst) && gst.length === 15;
  };

  const formatDate = (date) => {
    if (!date) return null;
    const [year, month, day] = date.split("-");
    return `${month}/${day}/${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmailValid = validateEmail(email);
    const isPhoneValid = validatePhone(phone);
    const isGstValid = validateGst(gst);
    setIsEmailValid(isEmailValid);
    setIsPhoneValid(isPhoneValid);
    setIsGstValid(isGstValid);

    if (isEmailValid && isPhoneValid && isGstValid) {
      try {
        const selectedPlan = subscriptionPlans?.find(p => p._id === subscriptionId);

        const userData = {
          email,
          name,
          phone,
          password,
          device,
          subscription: selectedPlan ? selectedPlan.planevalidity : "",
          date: formatDate(date),
          address,
          proffesion,
          gst,
          cuponapplied,
          companyname,
          createdby,
          usertype,
          isEmailVerified: true,
          isPhoneVerified: true,
        };

        await axios.post(
          `${Constant.BASE_URL}/user/signup`,
          userData
        );

        toast.success("User created successfully");
        setTimeout(() => handleClose(), 1500);
      } catch (error) {
        console.error(error);
        const errorMessage = error.response?.data?.message || "An error occurred";
        toast.error(errorMessage);
      }
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    onClose();
  };

  useEffect(() => {
    const handleClickOutside = () => setIsSubscriptionOpen(false);
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return isVisible ? (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="popup-form">
        <div className="w-full flex items-center justify-center">
          <div className="bg-white p-4 rounded-md shadow-md py-3 px-1 w-fit">
            <div className="lg:w-[600px] xl:w-[630px] 2xl:w-[1350px] items-center justify-center">
              <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl 2xl:py-3">
                Create User
              </div>
              <hr className="mt-1 " />

              <form onSubmit={handleSubmit}>
                <div className="flex items-center justify-center lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                  <div className="pr-3 border-r ">
                    <div className="flex py-3 justify-end mt-4">
                      <label htmlFor="name" className=" flex items-center px-3 ">Name :<span className="text-red-500 ml-1">*</span></label>
                      <input type="text" id="name" className="border-b border-gray-500 outline-none createuserline" placeholder="name" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>
                    <div className="flex py-3 text-gray-500 justify-end">
                      <label htmlFor="usertype" className="mb-1 text-gray-900 flex items-center px-3">UserType :<span className="text-red-500 ml-1">*</span></label>
                      <div className="relative borderuser">
                        <select id="usertype" className=" border-b border-gray-500 appearance-none outline-none bg-white createuserline" value={usertype} onChange={(e) => setUsertype(e.target.value)} required>
                          <option value="" disabled>Select</option>
                          <option value="Demo">Demo</option>
                          <option value="Sales">Sales</option>
                        </select>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"><MdArrowDropDown className="text-1xl" /></span>
                      </div>
                    </div>
                    <div className="flex py-3 justify-end">
                      <label htmlFor="phone" className="mb-1 flex items-center px-3">Phone :<span className="text-red-500 ml-1">*</span></label>
                      <div className="flex flex-col">
                        <input type="text" id="phone" className="border-b border-gray-500 outline-none createuserline" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone" required />
                        {!isPhoneValid && (<p className="text-red-500">Invalid phone format (10 digits)</p>)}
                      </div>
                    </div>
                    <div className="flex py-3 justify-end">
                      <label htmlFor="yourIn" className="mb-1 flex items-center px-3">Email :<span className="text-red-500 ml-1">*</span></label>
                      <div className="flex flex-col">
                        <input type="email" id="yourIn" className="border-b border-gray-500 outline-none createuserline" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                        {!isEmailValid && (<p className="text-red-500 ml-1">Invalid email format</p>)}
                      </div>
                    </div>
                    <div className="flex py-3 justify-end relative">
                      <label htmlFor="password"className="mb-1 flex items-center px-3">Password :<span className="text-red-500 ml-1">*</span></label>
                      <input type={togglePassword ? "text" : "password"} id="password" className="border-b border-gray-500 outline-none createuserline " placeholder="....." value={password} onChange={(e) => setPassword(e.target.value)} required />
                      <span onClick={() => setTogglePassword(!togglePassword)} className="absolute inset-y-0 right-2 flex items-center pr-2 cursor-pointer">{togglePassword ? <IoEye /> : <RiEyeCloseLine />}</span>
                    </div>
                    <div className="flex py-3 text-gray-500 justify-end">
                      <label htmlFor="device" className="mb-1 text-gray-900 flex items-center px-3">Device :<span className="text-red-500 ml-1">*</span></label>
                      <div className="relative borderuser">
                        <select id="device" className=" border-b border-gray-500 appearance-none outline-none bg-white createuserline" value={device} onChange={(e) => setDevice(e.target.value)} required>
                          <option value="" disabled>Select</option>
                          <option value="Android">Android</option>
                          <option value="IOS">IOS</option>
                        </select>
                        <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"><MdArrowDropDown className="text-1xl" /></span>
                      </div>
                    </div>
                    <div className="flex py-3 text-gray-500 justify-end">
                       <label htmlFor="subscription" className="mb-1 text-gray-900 flex items-center px-3">Subscription: <span className="text-red-500 ml-1">*</span></label>
                       <div className="relative createuserline">
                           <button
                             type="button"
                             onClick={(e) => {
                                 e.stopPropagation();
                                 if (!isLoading && !error) {
                                     setIsSubscriptionOpen(!isSubscriptionOpen);
                                 }
                             }}
                             className="w-full border-b border-gray-500 text-left bg-white flex justify-between items-center"
                             disabled={isLoading || error}
                           >
                             <span className="truncate">
                                 {(() => {
                                     if (isLoading) return "Loading plans...";
                                     if (error) return "Error loading plans";
                                     if (!subscriptionId) return "Select";
                                     const plan = subscriptionPlans?.find(p => p._id === subscriptionId);
                                     return plan ? `Plan: ${plan.planname} (${plan.planevalidity})` : "Select";
                                 })()}
                             </span>
                             <MdArrowDropDown className={`transition-transform ${isSubscriptionOpen ? "rotate-180" : ""}`} />
                           </button>
 
                           {isSubscriptionOpen && !isLoading && !error && (
                             <div className="absolute top-full left-0 right-0 bg-white border border-gray-400 rounded-md shadow-lg z-50" style={{ maxHeight: "160px", overflowY: "auto" }}>
                                 {subscriptionPlans?.length > 0 ? (
                                     subscriptionPlans.map((plan) => (
                                         <div
                                             key={plan._id}
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 setSubscriptionId(plan._id);
                                                 setIsSubscriptionOpen(false);
                                             }}
                                             className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
                                         >
                                             {`Plan: ${plan.planname} (Validity: ${plan.planevalidity})`}
                                         </div>
                                     ))
                                 ) : (
                                     <div className="px-3 py-2 text-gray-500">No plans available</div>
                                 )}
                             </div>
                           )}
                       </div>
                     </div>
                  </div>
                  <div className="w-fit pb-4 pl-1 pr-2 flex-col">
                    <div className="flex pb-3 text-gray-500 relative justify-end">
                      <label htmlFor="date" className="mb-1 text-gray-900 flex items-center px-3">Date of Birth:</label>
                      <input type="date" id="date" className="border-b border-gray-500 outline-none createuserline" placeholder="Date" value={date} onChange={(e) => setDate(e.target.value)} max={new Date().toISOString().split("T")[0]}/>
                    </div>
                    <div className="flex text-gray-500 py-3 justify-end">
                      <label htmlFor="address" className="mb-1 text-gray-900 flex items-center px-3">Address :</label>
                      <input type="text" id="address" className="border-b border-gray-500 outline-none createuserline" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="address"/>
                    </div>
                    <div className="flex py-3 text-gray-500 justify-end">
                      <label htmlFor="proffesion" className=" mb-1 text-gray-900 flex items-center px-3">Profession :<span className="text-red-500 ml-1">*</span></label>
                      <div className="text-center relative">
                        <select id="proffesion" className=" border-b border-gray-500 appearance-none outline-none createuserline" value={proffesion} onChange={(e) => setProffesion(e.target.value)} required>
                          <option value="" disabled>Profession</option>
                          <option value="Fabric Manufacturer">Fabric Manufacturer</option>
                          <option value="Garment Manufacturer">Garment Manufacturer</option>
                          <option value="Yarn Manufacturer">Yarn Manufacturer</option>
                          <option value="Trader & Broker">Trader & Broker</option>
                          <option value="Buyer">Buyer</option>
                          <option value="Designer">Designer</option>
                          <option value="Finisher">Finisher</option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="absolute inset-y-0 right-0 flex items-center pointer-events-none"><MdArrowDropDown className="text-1xl" /></span>
                      </div>
                    </div>
                    <div className="flex py-3 justify-end">
                      <label htmlFor="gst" className="mb-1 flex items-center px-3">GST Number :</label>
                      <div className="flex flex-col">
                        <input type="text" id="gst" className={`border-b border-gray-500 outline-none createuserline ${ gst.length > 0 && !isGstValid ? "border-red-500" : "" }`} value={gst} onChange={(e) => setGst(e.target.value)} placeholder="gstnumber" />
                        {gst.length > 0 && !isGstValid && (<p className="text-red-500">Invalid GST number</p>)}
                      </div>
                    </div>
                    <div className="flex py-3 text-gray-500 justify-end">
                      <label htmlFor="companyname" className="mb-1 text-gray-900 flex items-center px-3">Company Name:</label>
                      <input type="text" id="companyname" className="border-b border-gray-500 outline-none createuserline" value={companyname} onChange={(e) => setCompanyname(e.target.value)} placeholder="Text"/>
                    </div>
                    <div className="flex py-3 justify-end">
                      <label htmlFor="yourInput" className="mb-1 flex items-center px-3">Created By :</label>
                      <input type="text" id="yourInput" className="text-[#BBB] border-b border-gray-500 outline-none createuserline" value={userName} readOnly required/>
                    </div>
                  </div>
                </div>
                <div className="button-container flex justify-center p-1 space-x-12 lg:pb-5 xl:pb-5 2xl:pb-5 lg:pt-10 xl:pt-10 2xl:pt-10 lg:text-[10px] xl:text-[13px] 2xl:text-[30px]">
                  <button type="button" onClick={handleClose} className=" bg-white px-3 rounded-sm py-1 flex-shrink-0 shadow-md" style={{ boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)" }}>Cancel</button>
                  <button type="submit" className="px-3 rounded-sm py-1 flex-shrink-0 " style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",}}>Create</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
}